import { LinearProgress } from '@mui/material';
import { ZfLoadingSpinner, ZfStack } from '@zafire/react';
import { useHost } from 'contexts/Host';

const LoadingIndicator = ({ id }: { id: string }) => {
  const { isWena } = useHost();

  if (isWena) {
    return (
      <ZfStack id={id} direction="row" justify="center" styles={{ padding: 'lg' }}>
        <ZfLoadingSpinner size="extra-large" />
      </ZfStack>
    );
  }

  return <LinearProgress id={id} color="secondary" />;
};

export default LoadingIndicator;
